import { render, staticRenderFns } from "./ykgkCov.vue?vue&type=template&id=f1328502&scoped=true"
import script from "./ykgkCov.vue?vue&type=script&lang=js"
export * from "./ykgkCov.vue?vue&type=script&lang=js"
import style0 from "./ykgkCov.vue?vue&type=style&index=0&id=f1328502&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1328502",
  null
  
)

export default component.exports